module.exports = __webpack_public_path__ + "img/agents.a2bd758f.svg";